<template>
  <!-- 用户列表 -->
  <div>
    <div class="clear buyed-users__item" v-for="(item,index) in userLists" :key="index" @click="goTo(item.id)">
      <avatar-box class="left" :avatar="item.largeAvatar" :auth="item.is_vip"></avatar-box>
      <div class="clear buyed-users__info">
        <div class="clear">
          <div class="left c4 fs2">{{ item.nickname }}</div>
          <!-- <div class="right c9 fs1">2018-08-07</div> -->
        </div>
        <div class="buyed-users__auth mtn fs1 c9">
          <!-- <i class="iconfont fs1 yellow">&#xe630;</i>  -->
          <span class="green">{{ item.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import AvatarBox from '@/components/AvatarBox'
import { Actionsheet } from 'vant';
Vue.use(Actionsheet);
export default {
components: {
    AvatarBox
  },
  props: {
    userLists: {
      type: Array,
      default: ''
    }
  },
  data() {
    return {
      
    }
  },
  methods: {    
    goTo:function(id){
      location.href=`${location.origin}`+'/training/#/userHome?userId='+id      
    }
  }
}
</script>

<style lang="less" scoped>
// 已购买者弹出层
.buyed-users {
    width: 80%;
    height: 100%;
    &__item {
      display: block;
      border-bottom: 0.01rem #f6f6f6 solid;
      padding: 0.15rem;
    }
    &__info {
        overflow: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UserList.vue